module.exports = __webpack_public_path__ + "static/img/china-1-bg.08f00d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/china/china-1-bg.png
// module id = 1381
// module chunks = 1